import { useState } from "react";
import { useTasks } from "../hooks/useTasks";
import { useTaskStore } from "../store/taskStore";
import { useFeatureFlag } from "../hooks/useFeatureFlag";
import { TaskCard } from "../components/TaskCard";
import { NotificationBanner } from "../components/NotificationBanner";

export default function Dashboard() {
  const { isLoading } = useTasks();
  const { getFilteredTasks, setFilter, filter } = useTaskStore();
  const showNewDashboard = useFeatureFlag("FF_NEW_DASHBOARD");
  const [announcement] = useState(
    '<strong>Welcome back!</strong> Sprint review is <em>tomorrow</em> at 3 PM.'
  );

  const tasks = getFilteredTasks();
  const stats = {
    total: tasks.length,
    todo: tasks.filter((t) => t.status === "todo").length,
    inProgress: tasks.filter((t) => t.status === "in-progress").length,
    done: tasks.filter((t) => t.status === "done").length,
  };

  return (
    <div className="flex-1 p-6 overflow-auto">
      <NotificationBanner />

      {/* XSS: dangerouslySetInnerHTML with user-controllable content */}
      <div
        className="mb-6 p-4 bg-blue-900/30 border border-blue-700 rounded-lg text-blue-200"
        dangerouslySetInnerHTML={{ __html: announcement }}
      />

      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">
          {showNewDashboard ? "Dashboard v2" : "Dashboard"}
        </h1>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Search tasks..."
            value={filter.search}
            onChange={(e) => setFilter({ search: e.target.value })}
            className="px-3 py-1.5 bg-dark-800 border border-dark-600 rounded text-sm text-white placeholder-dark-400 focus:outline-none focus:border-blue-500"
          />
          <select
            value={filter.status || ""}
            onChange={(e) => setFilter({ status: e.target.value || null })}
            className="px-3 py-1.5 bg-dark-800 border border-dark-600 rounded text-sm text-white focus:outline-none focus:border-blue-500"
          >
            <option value="">All Status</option>
            <option value="todo">To Do</option>
            <option value="in-progress">In Progress</option>
            <option value="done">Done</option>
          </select>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        {[
          { label: "Total", value: stats.total, color: "bg-dark-700" },
          { label: "To Do", value: stats.todo, color: "bg-yellow-900/40" },
          { label: "In Progress", value: stats.inProgress, color: "bg-blue-900/40" },
          { label: "Done", value: stats.done, color: "bg-green-900/40" },
        ].map((s) => (
          <div key={s.label} className={`${s.color} rounded-lg p-4 border border-dark-600`}>
            <p className="text-sm text-dark-300">{s.label}</p>
            <p className="text-2xl font-bold text-white">{s.value}</p>
          </div>
        ))}
      </div>

      {/* Task list */}
      {isLoading ? (
        <div className="text-center text-dark-400 py-12">Loading tasks...</div>
      ) : tasks.length === 0 ? (
        <div className="text-center text-dark-400 py-12">No tasks found</div>
      ) : (
        <div className="grid gap-3">
          {tasks.map((task) => (
            <TaskCard key={task.id} task={task} />
          ))}
        </div>
      )}
    </div>
  );
}
